import type { ILoginResponse } from "@/entities/auth/types.ts"
import { requestAuth } from "@/shared/utils/axios.ts"

export interface ILoginPayload {
  email: string
  password: string
}

export async function postLogin(body: ILoginPayload) {
  const { data } = await requestAuth.post("/login/", body)
  return data as ILoginResponse
}
